module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8023.523acb2b.png";